import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Waiver } from '../models/waiver';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class WaiverService {

  constructor(private http: HttpClient) { }

  get(id: string): Promise<Waiver> {
  	return this.getWithRest('id/' + id);
  }

  getForHorseShow(horse_show_id: string): Promise<Waiver> {
    return this.getWithRest('horse_show_id/' + horse_show_id);
  }

  private getWithRest(rest_url: string) : Promise<Waiver> {
    return new Promise((resolve, reject) => {
    return this.http.get(AppSettings.API_ENDPOINT + 'waivers/' + rest_url).subscribe((response:any) => {

      if(response.type == 'waiver' && response.data){
        resolve(response.data);
      } else {
        reject(response);
      }

    },
      error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
  });
  }

}
